module.exports = __webpack_public_path__ + "static/img/u70058.537dba7e.png";